import { createContext } from 'react';

const UserLocationContext = createContext(null);

export { UserLocationContext };
